import { Separator } from 'components/Separator'
import { ComponentType } from 'react'
import { CoverBackground } from 'components/CoverBackground'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { Badges } from './badges'
import { Details } from './details'
import { Extract } from './extract'
import { Description } from './description'
import { Extras } from './extras'
import { Places } from './places'
import { Tabs } from './tabs'
import numeral from 'numeral'
import { Phone } from './agent/phone'

const Wrapper = styled.div`
  padding-bottom: 10px;
`

const Image = styled(CoverBackground)`
  width: 64px;
  height: 64px;
  border-radius: 64px;
  margin-right: 16px;
`

const Info = styled.div`
  flex: 1;
`

const Name = styled.h6`
  margin: 0;
  font-size: 16px;
`

const Tag = styled.span`
  color: #757d88;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
`

interface Props {
  property: any
  agent: any
  beforeOnShareClick: () => Promise<void>
  shareUrl: string
}

export const PropertyPrint: ComponentType<Props> = ({ property, agent, beforeOnShareClick, shareUrl }) => {
  return (
    <Wrapper>
      <Container>
        <Row>
          <Col sm={8} className="print--title">
            <Extract property={property} />
          </Col>
          <Col sm={4} className="print--price">
            <h3>
              {numeral(property.sale.price).format('$0,0')} {property.currency}
            </h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <Badges property={property} />
          </Col>
        </Row>
        <Row>
          <Col sm={8}>
            {
              property.gallery[0] &&
              <img src={property.gallery[0].secureUrl} className="print--gallery-main" />
            }
          </Col>
          <Col sm={4}>
            <Row>
              <Col>
                {
                  property.gallery[1] &&
                  <img src={property.gallery[1].secureUrl} className="print--gallery-secondary" />
                }
              </Col>
            </Row>
            <Row>
              <Col>
                {
                  property.gallery[2] &&
                  <img src={property.gallery[2].secureUrl} className="print--gallery-secondary" />
                }
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="print--extract">
          <Col>
            <Extract property={property} />
            <Separator />
            <Places property={property} />
          </Col>
          <Col>
            <Details property={property} />
            <Extras property={property} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Separator className="print--margin-bottom" />
          </Col>
        </Row>
        <Row>
          <Col className="print--area print--page-break">
            <Tabs property={property} />
          </Col>
          <Col className="print--measurements print--page-break">
            <Tabs property={property} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Description property={property} />
          </Col>
        </Row>
      </Container>
    </Wrapper >
  )
}
